import { OvertimeSnapshotEntry } from './types';

const formatNumber = (n: number): string => {
  // Trim trailing zeros but keep integers clean (12.5 -> "12.5", 12 -> "12").
  return Number.isInteger(n) ? `${n}` : `${parseFloat(n.toFixed(2))}`;
};

export const formatOvertimeEntryQuantity = (entry: OvertimeSnapshotEntry): string => {
  const hours = parseFloat(entry.totalOtHours ?? '0') || 0;
  const days = parseFloat(entry.totalOtDays ?? '0') || 0;
  const parts: string[] = [];
  if (hours > 0) {
    parts.push(`${formatNumber(hours)} hrs`);
  }
  if (days > 0) {
    parts.push(`${formatNumber(days)} ${days === 1 ? 'day' : 'days'}`);
  }
  return parts.join(' · ');
};
